/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_User_Admin_GrantedInputs */



/**
* | output |
* | --- |
* | "Admin Rights Granted" |
*
* @param {Audit_Details_User_Admin_GrantedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_user_admin_granted = /** @type {((inputs?: Audit_Details_User_Admin_GrantedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_User_Admin_GrantedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Adminrechte erteilt")
	return /** @type {LocalizedString} */ ("Admin Rights Granted")
});